import React from "react";

import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    flex: "none",
    width: "100%",
    height: 72,
    minWidth: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    flexWrap: "nowrap",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      height: 64,
    },
  },
  backButton: {
    flexShrink: 0,
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(0.25),
    },
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleBack = () => {
    history.push("/tickets");
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square className={classes.ticketHeader}>
          <IconButton className={classes.backButton} color="primary" onClick={handleBack}>
            <ArrowBackIos />
          </IconButton>
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
